import React from 'react';
import { useIsMobile } from '../../hooks/useMediaQuery';

const BottomNav = ({ activeTab, onTabChange, userRole }) => {
  const isMobile = useIsMobile();

  if (!isMobile) return null;

  const getNavItems = () => {
    if (userRole === 'manager') {
      return [
        { id: 'add', icon: '💰', label: 'Napiwki' },
        { id: 'summary', icon: '📊', label: 'Podsumowanie' },
        { id: 'reports', icon: '📈', label: 'Raporty' },
        { id: 'menu', icon: '☰', label: 'Menu' }
      ];
    } else {
      // Waiter/Cook
      return [
        { id: 'add', icon: '➕', label: 'Dodaj' },
        { id: 'summary', icon: '📊', label: 'Moje' },
        { id: 'training', icon: '📚', label: 'Szkolenie' },
        { id: 'menu', icon: '☰', label: 'Menu' }
      ];
    }
  };

  const navItems = getNavItems();

  return (
    <nav
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: '72px',
        background: 'rgba(11, 14, 20, 0.85)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        borderTop: '1px solid rgba(255, 255, 255, 0.05)',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: '8px 0',
        zIndex: 'var(--z-bottom-nav)',
        boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.3)'
      }}
      data-testid="mobile-bottom-nav"
    >
      {navItems.map((item) => (
        <button
          key={item.id}
          onClick={() => onTabChange(item.id)}
          data-testid={`bottom-nav-${item.id}`}
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
            color: activeTab === item.id ? 'var(--gold)' : 'var(--text-muted)',
            transition: 'all 0.2s ease',
            minHeight: 'var(--touch-target-min)',
            position: 'relative'
          }}
          onTouchStart={(e) => {
            e.currentTarget.style.transform = 'scale(0.95)';
          }}
          onTouchEnd={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          <span style={{ fontSize: '24px', lineHeight: 1 }}>{item.icon}</span>
          <span
            style={{
              fontSize: '11px',
              fontWeight: activeTab === item.id ? '600' : '400',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}
          >
            {item.label}
          </span>
          {activeTab === item.id && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '40px',
                height: '3px',
                background: 'var(--gold)',
                borderRadius: '0 0 3px 3px'
              }}
            />
          )}
        </button>
      ))}
    </nav>
  );
};

export default BottomNav;
